module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "master",
    staticClass: "drag-and-drop column",
    class: {
      dragging: _vm.isDragging
    },
    on: {
      "click": _vm.fileInput
    }
  }, [(!_vm.file) ? _c('span', {
    staticClass: "icon-form-plus"
  }) : _vm._e(), _vm._v(" "), (!_vm.file) ? _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\tDéposer votre fichier\n\t\t")]) : _c('div', {
    staticClass: "ctn-file column"
  }, [_c('div', {
    staticClass: "ctn-icon-document"
  }, [_c('img', {
    attrs: {
      "src": _vm.baseFile,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "extension"
  }, [_vm._v("." + _vm._s(_vm._f("uppercase")(_vm.file.name)))])]), _vm._v(" "), _c('div', {
    staticClass: "file-name"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.file.name) + "\n\t\t\t")])]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "input-file",
      "type": "file"
    },
    on: {
      "change": _vm.setFile
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a6a48f9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/Form/DragAndDrop.vue
// module id = 1078
// module chunks = 0